// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class CarouselSliderButton extends Component {
  /**
   * Instantiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    const clickHandler = this.handleClickEvents.bind(this);
    this.addEventListener(EventNames.CLICK, clickHandler);
  }

  /**
   * Executes when the component is clicked
   */
  handleClickEvents(e: Event) {
    e.preventDefault();
    this.notify(Notifications.CAROUSEL_CHANGE_INDEX, { index: this.index });
    this.notify(Notifications.RESET_ZOOM);
  }

  /**
   * Retrieve the index of the button
   */
  get index(): number {
    return +this.el.dataset.index;
  }

  /**
   * Set the index of the button
   *
   * @param index
   */
  set index(index: number): void {
    this.el.dataset.index = index;
  }
}
